// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"275":"a3e278c7","7320":"9e922fd1","7339":"9e922fd1"}[chunkId] + ".chunk.css";
};